import { scaleLinear, axisBottom, axisLeft, select } from 'd3';

import appConfig from 'scripts/app-config';

const holesAmount = appConfig.holesAmount;

const margin = {
    left: 0,
    bottom: 0,
    top: 0,
    right: 0,
};
const chartColor = 'rgb(255, 255, 255, 0.1)';
const textColor = 'rgb(255, 255, 255, 0.5)';
const yAxisTicks = 4;

export const getX = (width) => {
    return scaleLinear()
        .domain([0, holesAmount])
        .range([margin.left, width - margin.right]);
};

export const getY = (height, max = 1) => {
    return scaleLinear()
        .domain([0, max])
        .range([height - margin.bottom, margin.top]);
};

const yAxisFormat = (y) => {
    return `${Math.floor(y * 100)}%`;
};

const getYAxis = (height, max) => {
    return axisLeft(getY(height, max))
        .ticks(yAxisTicks)
        .tickFormat(yAxisFormat);
};

export const getXAxis = (width, holes) => {
    return axisBottom(getX(width))
        .ticks(holesAmount)
        .tickFormat((i) => holes[i]);
};

const defautAxisPatch = (axis) => {
    return axis
        .call((g) => g.selectAll('.tick text').attr('color', textColor))
        .call((g) => g.select('.domain').remove());
};

export const addXAxis = (svg, width, height, holes) => {
    const axis = svg
        .append('g')
        .attr('class', 'chart-x-axis')
        .attr('transform', `translate(0, ${height - margin.bottom})`)
        .call(getXAxis(width, holes))
        .call((g) =>
            g
                .selectAll('.tick line')
                .attr('stroke', chartColor)
                .attr('stroke-dasharray', '5,5')
                .attr('y2', margin.bottom + margin.top - height),
        );

    return defautAxisPatch(axis);
};

export const addYAxis = (svg, width, height, max) => {
    const axis = svg
        .append('g')
        .attr('class', 'chart-y-axis')
        .attr('transform', `translate(${margin.left}, 0)`)
        .call(getYAxis(height, max))
        .call((g) =>
            g
                .selectAll('.tick line')
                .attr('stroke', chartColor)
                .attr('x2', width - margin.left),
        );

    return defautAxisPatch(axis);
};

export const addChartBackground = (svg, width, height) => {
    svg.selectAll('rect').remove();
    return svg
        .append('rect')
        .attr('transform', `translate(${margin.left}, ${margin.top})`)
        .attr('width', width - margin.left)
        .attr('height', height - margin.top - margin.bottom)
        .style('fill', 'rgb(255, 255, 255, 0.1)');
};

export const getChartData = (chartContainer) => {
    const svgElement = chartContainer.find('svg.js-chart-area').get(0);

    if (!svgElement) {
        return {};
    }
    const rect = svgElement.getBoundingClientRect();

    return {
        width: rect.width,
        height: rect.height,
        svg: select(svgElement),
    };
};
